module.exports = __webpack_public_path__ + "static/img/LimitedOfferBannerAd.1032a4e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/LimitedOfferBannerAd.png
// module id = jLu0
// module chunks = 1